import { render, staticRenderFns } from "./AddCustomerList.vue?vue&type=template&id=f71cc246&scoped=true&"
import script from "./AddCustomerList.vue?vue&type=script&lang=js&"
export * from "./AddCustomerList.vue?vue&type=script&lang=js&"
import style0 from "./AddCustomerList.vue?vue&type=style&index=0&id=f71cc246&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f71cc246",
  null
  
)

export default component.exports